import PropTypes from 'prop-types'
import { ButtonGroup } from 'react-bootstrap'
import 'gantt-task-react/dist/index.css'
import { ViewMode } from 'gantt-task-react'
import ButtonWithIcon from '../ButtonWithIcon.jsx'
import {MdViewModule, MdViewList, MdDateRange } from 'react-icons/md'

export const ViewSwitcher = ({
    onViewModeChange,
    onViewListChange,
    isChecked,
    currentView,
}) => {
    return (
        <div className='d-flex gap-3 align-items-center mb-3'>
            <ButtonGroup>
                {/*<ButtonWithIcon*/}
                {/*    icon={<MdViewDay />}*/}
                {/*    text='Dzień'*/}
                {/*    variant={*/}
                {/*        currentView === ViewMode.Day*/}
                {/*            ? 'primary'*/}
                {/*            : 'outline-primary'*/}
                {/*    }*/}
                {/*    size='sm'*/}
                {/*    onClick={() => onViewModeChange(ViewMode.Day)}*/}
                {/*/>*/}
                {/*<ButtonWithIcon*/}
                {/*    icon={<MdViewWeek />}*/}
                {/*    text='Tydzień'*/}
                {/*    variant={*/}
                {/*        currentView === ViewMode.Week*/}
                {/*            ? 'primary'*/}
                {/*            : 'outline-primary'*/}
                {/*    }*/}
                {/*    size='sm'*/}
                {/*    onClick={() => onViewModeChange(ViewMode.Week)}*/}
                {/*/>*/}
                <ButtonWithIcon
                    icon={<MdViewModule />}
                    text='Miesiąc'
                    variant={
                        currentView === ViewMode.Month
                            ? 'primary'
                            : 'outline-primary'
                    }
                    size='sm'
                    onClick={() => onViewModeChange(ViewMode.Month)}
                />
                <ButtonWithIcon
                    icon={<MdDateRange />}
                    text='Rok'
                    variant={
                        currentView === ViewMode.Year
                            ? 'primary'
                            : 'outline-primary'
                    }
                    size='sm'
                    onClick={() => onViewModeChange(ViewMode.Year)}
                />
            </ButtonGroup>

            <ButtonWithIcon
                icon={<MdViewList />}
                text={isChecked ? 'Ukryj listę zadań' : 'Pokaż listę zadań'}
                variant={isChecked ? 'secondary' : 'outline-secondary'}
                size='sm'
                onClick={() => onViewListChange(!isChecked)}
            />
        </div>
    )
}

ViewSwitcher.propTypes = {
    onViewModeChange: PropTypes.func.isRequired,
    onViewListChange: PropTypes.func.isRequired,
    isChecked: PropTypes.bool.isRequired,
    currentView: PropTypes.string.isRequired,
}
